import React, { Component } from "react";
import AntdDrawer, {DrawerProps} from 'antd/lib/drawer';
import 'antd/lib/drawer/style';

export default class Drawer extends Component<DrawerProps> {
    render() {
        return (
          <AntdDrawer {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/drawer/index.tsx